import React from "react";

const LandingFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="landing-footer">
      <div className="container footer-inner">
        <span className="footer-brand">FeraBio</span>
        <div className="footer-links">
          <a href="/">Privacy</a>
          <a href="/">Terms</a>
          <a href="/">Contact</a>
        </div>
        <span>FeraBiosciences &copy; {year}</span>
      </div>
    </footer>
  );
};

export default LandingFooter;
